module.exports = "pegasus_template/assets/preview-14.png";